import uber from '~assets/logo-uber.svg';
import peya from '~assets/logo-peya.svg';
import cabify from '~assets/logo-cabify.svg';
import rappi from '~assets/logo-rappi-cargo.png';
import { DELIVERY_TYPES } from '~constants/delivery';

export const DELIVERY_IMAGES = {
  [DELIVERY_TYPES.UBER]: uber,
  [DELIVERY_TYPES.PEYA]: peya,
  [DELIVERY_TYPES.CABIFY]: cabify,
  [DELIVERY_TYPES.UBER_DAAS]: uber,
  [DELIVERY_TYPES.PEYA_V3]: peya,
  [DELIVERY_TYPES.RAPPI_CARGO]: rappi
};
